var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"disabled:opacity-50 text-primary whitespace-nowrap",class:{
    'cursor-pointer': !_vm.disabled,
    'cursor-default': _vm.disabled,
  },attrs:{"content":_vm.title,"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_c('font-awesome-icon',{class:['fa-3x fill-current', _vm.textSizeClass, _vm.iconClasses, {
      'text-gray-500': _vm.disabled,
      'hover:text-dvbrandhoveron hover:underline': !_vm.disabled,
    }],attrs:{"icon":_vm.icon,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }